import React from 'react';

interface MicrosoftIconProps {
  color?: string;
  className?: string;
  size?: number;
  width?: number;
  height?: number;
}

const MicrosoftIcon: React.FC<MicrosoftIconProps> = ({ className = '', size, width = 24, height = 24 }) => {
  return (
    <svg
      aria-hidden="true"
      className={className}
      width={size ?? width}
      height={size ?? height}
      viewBox="-1.5 -1.5 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 0H0V11H11V0Z" fill="#F25022"/>
      <path d="M23 0H12V11H23V0Z" fill="#7FBA00"/>
      <path d="M11 12H0V23H11V12Z" fill="#00A4EF"/>
      <path d="M23 12H12V23H23V12Z" fill="#FFB900"/>
    </svg>
  );
};

export default MicrosoftIcon;
